// extracted by mini-css-extract-plugin
export default {"shadow":"shadowtop_shadow__G6kTQ"};